<template>

  <v-app-bar
    elevation="0"
    class="main-header"
    height="64"
    fixed
    color='white'
    dark>

    <v-toolbar-title>
      <router-link to="/home">
        <v-img v-if="customer.logoUrl === undefined || customer.logoUrl === null" height="25" contain src="@/assets/logo-viewelevator-blue.png"></v-img>
        <v-img v-else height="25" contain :src="getPath()"></v-img>
      </router-link>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <UserMenu
        :user="user"
        v-if="isLoggedIn"
    />

    <!-- LanguageSelector -->
    <LanguageMenu />

    <v-btn color="primary"
           text
           rounded
           class="my-2 text-capitalize"
           v-if="!isLoggedIn"
           @click="clickLogin()">
      {{ loginText }}
    </v-btn>

  </v-app-bar>
</template>

<script>
import {Translator} from '../../../../plugins/translation';
import UserMenu from '@/modules/core/components/Header/UserMenu';
import UsersService from '@/modules/core/services/users-service';
import DataUtils from '@/modules/core/services/data-utils';
import Users from '@/modules/core/data/users';
import Vue from 'vue';
import {mapGetters} from 'vuex';
import LanguageMenu from '@/modules/core/components/Header/LanguageMenu';
import Customer from "@/modules/core/data/customer";
import CustomerService from "@/modules/core/services/customer-service";

export default {
  name: 'PublicHeader',
  components: {
    LanguageMenu,
    UserMenu
  },
  data: () => ({
    user: {},
    customer: {},
  }),
  methods: {
    getPath() {
      if (this.customer === undefined || this.customer.logoUrl === undefined)
        return;

      return process.env.VUE_APP_ROOT_HOST + this.customer.logoUrl + "?" + Math.random();
    },
    clickLogin() {
      window.location.replace(Vue.$keycloak.createLoginUrl());
    }
  },
  computed: {
    supportedLocales() {
      return Translator.supportedLocales;
    },
    loginText() {
      return this.$t('utils:PublicHeader.login')
    },
    ...mapGetters('auth', ['isLoggedIn']),
  },
  created() {
    if (this.isLoggedIn) {
      UsersService.readProfileFromAPI(
          (resp) => {
            var response = DataUtils.parseDataToSingleObject(resp.data, Users);
            if (response == null) {
              this.$logger.error("Failed to receive user data!");
            } else {
              this.user = response;
              CustomerService.readProfileFromAPI(
                  (resp) => {
                    var response = DataUtils.parseDataToSingleObject(resp.data, Customer);
                    this.customer = response;
                  })
            }
          }
      )
    }
  }
}
</script>

<style src="@/modules/core/components/Header/Header.scss" lang="scss"></style>
